import React from "react";
import { TableRow } from "@mui/material";
import { StyledTableCell } from "../../../../../../shared/components/CustomTable/Styled";
import Status from "../../../../../../shared/components/Status";

interface TopProduct {
    rank: number;
    product_code: string;
    product_name: string;
    percentage: number;
    quantity_sold: number;
}

const getColorTheme = (rank: number) => {
    switch (rank) {
        case 1:
            return "INFO";
        case 2:
            return "SUCCESS";
        case 3:
            return "PENDING";
        case 4:
            return "WARNING";
        case 5:
        default:
            return "FAIL";
    }
};

export const TopProductRow = ({ item }: { item: TopProduct }) => {
    return (
        <TableRow>
            <StyledTableCell align="left">{item.rank}</StyledTableCell>
            <StyledTableCell align="left">{item.product_name}</StyledTableCell>
            <StyledTableCell align="left">{item.quantity_sold}</StyledTableCell>
            <StyledTableCell align="left">
                <Status
                    text={item.percentage.toString() + "%"}
                    colorTheme={getColorTheme(item.rank)}
                    width="28px"
                />
            </StyledTableCell>
        </TableRow>
    );
};
